import usePaginatedLogList, { withMasterReview } from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Popconfirm, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL, decklogdownloadPdfUrl } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { SuccessToast } from "../../../widgets/AppToast";
const { RangePicker } = DatePicker;

const DeckLogBookList = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const { data: filteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.list_deck_logs, "logs", withMasterReview);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage.id) LIST_DECK_LOGBOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_DECK_LOGBOOK_API = (voyage_id) => {
    if (!voyage_id) return;
    return loadRecords({ voyage_id });
  };

  const DELETE_DECK_LOG_API = async (deck_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("deck_log_id", deck_id);
    try {
      post(ApiURL.delete_deck_log, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success Message !", res?.message);
          LIST_DECK_LOGBOOK_API(voyage_ids);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (voyage_ids) LIST_DECK_LOGBOOK_API(voyage_ids);
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "deck_log_id",
      align: "center",
      key: "deck_log_id",
      sorter: (a, b) => a.deck_log_id - b.deck_log_id,
    },
    {
      title: "Voyage No",
      dataIndex: "voyage",
      key: "voyage",
      align: "center",
    },
    {
      title: "Latitude",
      dataIndex: "latitude",
      align: "center",
      key: "latitude",
    },
    {
      title: "Longitude",
      dataIndex: "longitude",
      align: "center",
      key: "longitude",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Created For",
      dataIndex: "log_date_time",
      align: "center",
      key: "log_date_time",
      render: (text, record) => formatDate(record?.log_date_time),
    },
     {
          title: (
            <Tooltip title={"No selections"}>
              <div style={{ textAlign: "center" }}>
                <span>Reviewed By Master</span>
                <Checkbox
                  style={{ marginLeft: 8 }}
                  checked={
                    filteredData.length > 0 &&
                    filteredData.every((item) => item.masterReviewed)
                  }
                  indeterminate={
                    filteredData.some((item) => item.masterReviewed) &&
                    !filteredData.every((item) => item.masterReviewed)
                  }
                  disabled
                />
              </div>
            </Tooltip>
          ),
          dataIndex: "master_review",
          align: "center",
          key: "master_review",
          render: (text, record, index) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Checkbox checked={record.masterReviewed} disabled />
              <span
                style={{
                  marginLeft: 8,
                  textDecoration: record?.soft_delete ? "line-through" : "none",
                }}
              >
                Reviewed By Master
              </span>
            </div>
          ),
        },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <>
          {/* Edit Button with Tooltip */}
          <Tooltip
            title={
              !voyage_status
                ? "Editing is disabled when voyage status is inactive."
                : "Edit"
            }
          >
            <span>
              <Button
                disabled={!voyage_status}
                type="primary"
                size="small"
                onClick={() =>
                  navigate(`/edit-deck-log/${btoa(record.deck_log_id)}`)
                }
                style={{ marginRight: "5px" }}
                icon={<EditOutlined />}
              />
            </span>
          </Tooltip>

          {/* Delete Button with Confirmation */}
          <Popconfirm
            title="Delete Deck Logbook"
            description="Are you sure you want to delete this Deck Logbook? This action cannot be undone."
            onConfirm={() => DELETE_DECK_LOG_API(record?.deck_log_id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button
                type="primary"
                size="small"
                style={{ marginLeft: "5px" }}
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-deck-log"),
          onPress: () => navigate("/audit-trail-deck"),
        }}
      />

      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_DECK_LOGBOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  decklogdownloadPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <LogListError error={error} retry={retry} />
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="deck_log_id"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default DeckLogBookList;
